import { render, staticRenderFns } from "./BoardExceptionSetting.vue?vue&type=template&id=0f54c0c0&"
import script from "./BoardExceptionSetting.vue?vue&type=script&lang=ts&"
export * from "./BoardExceptionSetting.vue?vue&type=script&lang=ts&"
import style0 from "./BoardExceptionSetting.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports